module.exports = __webpack_public_path__ + "static/media/Books.ca8106f3.png";